import { useMutation, useQueryClient } from '@tanstack/react-query';
import { customInstance } from '@/common/infrastructure/http/apiClient';
import type { Block, BlockKind } from '@/blocks/domain/types';
import { SUPPRESS_GLOBAL_ERROR_TOAST } from '@/common/application/constants/mutationMeta';
import { blocksQueryKey } from '@/blocks/application/hooks/useBlocks';

export interface CreateBlockPayload {
  kind: BlockKind;
  name?: string;
}

export const useCreateBlock = () => {
  const queryClient = useQueryClient();

  return useMutation({
    // NewBlockDialog renders the failure inline; without this the CRM host toasts it a second time.
    meta: SUPPRESS_GLOBAL_ERROR_TOAST,
    mutationFn: async (payload: CreateBlockPayload): Promise<Block> => {
      const trimmedName = payload.name?.trim();
      return customInstance<Block>({
        url: '/api/pdf-templates/v1/blocks',
        method: 'POST',
        data: {
          kind: payload.kind,
          ...(trimmedName ? { name: trimmedName } : {})
        }
      });
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: blocksQueryKey });
    }
  });
};
